import { Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { DataServiceService } from '../../services/data-service.service';

@Component({
  selector: 'app-pricelist',
  templateUrl: './pricelist.component.html',
  styleUrl: './pricelist.component.scss'
})
export class PricelistComponent {
  pricelistStandardDataSource: any;
  billingTypeDataSource: any;
  serviceDataSource: any;
  priceListTierType: any;
  priceListCycle: any;
  priceListStatusType: any;

  constructor(private dataService: DataServiceService) {
    this.pricelistStandardDataSource = dataService.getPricelistStandardDataSource();
    //
    this.billingTypeDataSource = dataService.getBillingTypeDataSource();
    this.serviceDataSource = dataService.getServiceDataSource();

    this.priceListTierType = dataService.getPriceListType();
    this.priceListCycle = dataService.getPriceListCycle();
    this.priceListStatusType = dataService.getPriceListStatusType();
  }

}
